export default __webpack_public_path__ + "static/media/egypt.b327a1a4.png";